import React, { PureComponent } from 'react';
import A11yFontIcon from 'components/A11yFontIcon';
import TextButton from 'components/TextButton';
import { addChatTags, clearCallbacks, setCallbacks } from 'utils/zendesk';
import './SurveyPalModal.css';

const IFRAME_UNMOUNTED = 0;
const IFRAME_MOUNTED = 1;
const IFRAME_VISIBLE = 2;

const SURVEY_ID = '1607525153';
const SURVEY_HASH =
  'op7rZl5-_wE7VO3A1n0CAS1kFbc28KDPXoalQilvFnTgAt7Ut4c9l_P_3Yg5wL_W';
const SURVEY_URL = `https://my.surveypal.com/app/form/ext?sid=${SURVEY_ID}&sh=${SURVEY_HASH}`;

class SurveyPalModal extends PureComponent {
  state = {
    answerId: null,
    iframeState: IFRAME_UNMOUNTED
  };

  componentDidMount() {
    setCallbacks({
      onChatStart: this.handleChatStart,
      onChatEnd: this.handleChatEnd
    });
  }

  componentWillUnmount() {
    clearCallbacks({
      onChatStart: this.handleChatStart,
      onChatEnd: this.handleChatEnd
    });
  }

  handleChatStart = () => {
    const answerId = createAnswerId();
    addChatTags([answerId]);
    this.setState({
      answerId,
      iframeState: IFRAME_MOUNTED
    });
  };

  handleChatEnd = () => {
    this.setState({
      iframeState: IFRAME_VISIBLE
    });
  };

  handleCloseSurvey = () => {
    this.setState({
      iframeState: IFRAME_UNMOUNTED
    });
  };

  render() {
    const { iframeState, answerId } = this.state;

    if (iframeState === IFRAME_UNMOUNTED) {
      return null;
    }

    const stateClass =
      iframeState !== IFRAME_VISIBLE ? ' survey-pal-modal-hidden' : '';

    return (
      <div className={`survey-pal-modal${stateClass}`}>
        <iframe
          title="Customer Survey"
          src={`${SURVEY_URL}&extid=${answerId}`}
        />
        <div className="survey-header">
          <span>Customer Survey</span>
          <TextButton className="close-button" onClick={this.handleCloseSurvey}>
            <A11yFontIcon icon="close" alt="Close Survey" />
          </TextButton>
        </div>
      </div>
    );
  }
}

function createAnswerId() {
  // generation code based on https://support.surveypal.com/hc/en-us/articles/360020662199-Embedding-survey-to-Zendesk-chat
  let e = Date.now();
  let result = 'surveypalid_';
  for (let i = 0; i < 16; ++i) {
    const n = (e + 16 * Math.random()) % 16 | 0;
    e = Math.floor(e / 16);
    result += n.toString(16);
  }
  return result;
}

export default SurveyPalModal;
